export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "compiler.worker.7d6098597f14fd0579b3.worker.js");
}
